import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, Quote, Star } from 'lucide-react';
import { TESTI } from '@/constants/testIds';

const quotes = [
  {
    text: 'The owner is so responsive, offers tailoring, and very kind.',
    author: 'Verified Google Review',
  },
  {
    text: 'Thank you very much for the amazing service and excellent selection.',
    author: 'Verified Google Review',
  },
  {
    text: 'Amazing collection, excellent pricing and superb customer relationships.',
    author: 'Verified Google Review',
  },
];

export const Testimonials = () => {
  const [i, setI] = useState(0);
  const next = () => setI((p) => (p + 1) % quotes.length);
  const prev = () => setI((p) => (p - 1 + quotes.length) % quotes.length);

  useEffect(() => {
    const t = setInterval(next, 6000);
    return () => clearInterval(t);
  }, []);

  return (
    <section data-testid={TESTI.root} className="py-24 lg:py-32 bg-ivory relative overflow-hidden">
      {/* corner mandalas */}
      <svg className="absolute -left-20 top-10 w-64 h-64 opacity-[0.08] text-maroon" viewBox="0 0 200 200" aria-hidden>
        <g stroke="currentColor" fill="none" strokeWidth="0.5" transform="translate(100 100)">
          {[...Array(20)].map((_, k) => (
            <g key={k} transform={`rotate(${k * 18})`}>
              <path d="M0 0 C 25 -8, 50 -22, 75 0 C 50 22, 25 8, 0 0 Z" />
            </g>
          ))}
          <circle r="80" strokeDasharray="2 5" />
        </g>
      </svg>

      <div className="container-luxe relative">
        <div className="text-center max-w-2xl mx-auto">
          <span className="overline">Kind Words</span>
          <h2 className="font-display text-4xl lg:text-5xl text-charcoal mt-3 leading-tight">
            Loved by our <em className="text-maroon not-italic font-medium">community</em>.
          </h2>
          <div className="mt-5 flex items-center justify-center gap-2">
            {[...Array(5)].map((_, k) => (
              <Star key={k} className="w-5 h-5 fill-gold text-gold" />
            ))}
            <a
              href="https://www.google.com/search?q=Trendy+Closet+Indian+Clothing+Reviews"
              target="_blank" rel="noreferrer"
              className="ml-2 text-sm text-charcoal/70 hover:text-maroon transition-colors underline-offset-4 hover:underline"
            >
              5.0 · 40+ Google Reviews
            </a>
          </div>
        </div>

        <div className="relative mt-14 max-w-3xl mx-auto">
          <Quote className="absolute -top-6 -left-2 w-12 h-12 text-gold/40" />
          <AnimatePresence mode="wait">
            <motion.blockquote
              key={i}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.6 }}
              className="text-center px-6"
            >
              <p className="font-display text-2xl md:text-3xl lg:text-[34px] leading-snug text-charcoal italic">
                “{quotes[i].text}”
              </p>
              <footer className="overline mt-8 block">— {quotes[i].author}</footer>
            </motion.blockquote>
          </AnimatePresence>

          <div className="flex items-center justify-center gap-6 mt-12">
            <button
              onClick={prev}
              data-testid={TESTI.prev}
              aria-label="Previous testimonial"
              className="w-11 h-11 border border-brandborder hover:border-maroon text-charcoal hover:text-maroon flex items-center justify-center transition-colors"
            >
              <ChevronLeft className="w-4 h-4" />
            </button>
            <div className="flex gap-2">
              {quotes.map((_, k) => (
                <button
                  key={k}
                  data-testid={TESTI.dot(k)}
                  onClick={() => setI(k)}
                  aria-label={`Go to testimonial ${k + 1}`}
                  className={`h-1.5 transition-all duration-500 ${
                    i === k ? 'w-10 bg-maroon' : 'w-4 bg-brandborder'
                  }`}
                />
              ))}
            </div>
            <button
              onClick={next}
              data-testid={TESTI.next}
              aria-label="Next testimonial"
              className="w-11 h-11 border border-brandborder hover:border-maroon text-charcoal hover:text-maroon flex items-center justify-center transition-colors"
            >
              <ChevronRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
